<template>
  <v-card>
     <v-card-title>
       <v-icon x-large>mdi-wall</v-icon>
       <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Filtro"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
    :headers="headers"
    :items="rolerights"
    :search="search"
    sort-by="calories"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="900px">
          <!--<template v-slot:activator="{ on }">
            <v-btn color="accent" dark class="mb-2" v-on="on">New Item</v-btn>
          </template>-->
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-row>
                    <v-col cols="6" sm="6" md="12">
                      <v-select
                        v-model="editedItem.ApiRole_id"
                        :items="roles"
                        :rules="idRules"
                        label="Role ID"
                        required
                      ></v-select>
                    </v-col>
                    <v-col cols="6" sm="6" md="12">
                      <v-select
                        v-model="editedItem.ApiProcess_id"
                        :items="processes"
                        :rules="procidRules"
                        label="Proceso ID"
                        required
                      ></v-select>
                    </v-col>
                    <v-col cols="6" sm="6" md="4">
                      <v-select
                        v-model="editedItem.ApiEnableRight_Ind"
                        :items="['S', 'N']"
                        :rules="[v => !!v || 'Item is required']"
                        label="Habilitado Ind"
                        required
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="close">Cancel</v-btn>
              <v-btn :disabled="!valid" color="accent" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_new" max-width="900px">
          <template v-slot:activator="{ on }">
            <v-btn color="accent" dark class="mb-2" v-on="on">NUEVO PERMISO</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-row>
                    <v-col cols="6" sm="6" md="12">
                      <v-select
                        v-model="editedItem.ApiRole_id"
                        :items="roles"
                        :rules="idRules"
                        label="Role ID"
                        required
                      ></v-select>
                    </v-col>
                    <v-col cols="6" sm="6" md="12">
                      <v-select
                        v-model="editedItem.ApiProcess_id"
                        :items="processes"
                        :rules="procidRules"
                        label="Proceso ID"
                        required
                      ></v-select>
                    </v-col>
                    <v-col cols="6" sm="6" md="4">
                      <v-select
                        v-model="editedItem.ApiEnableRight_Ind"
                        :items="['S', 'N']"
                        :rules="[v => !!v || 'Item is required']"
                        label="Habilitado Ind"
                        required
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="close">Cancel</v-btn>
              <v-btn :disabled="!valid" color="accent" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="accent" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
  </v-card>
</template>

<script>
import axios from 'axios'
export default {
  data: () => ({
    search: '',
    api_tool_url: process.env.VUE_APP_API_TOOL_URL,
    dialog: false,
    dialog_pass: false,
    dialog_new: false,
    valid: true,
    headers: [
      { text: 'Role ID', value: 'ApiRole_id' },
      { text: 'Proceso ID', value: 'ApiProcess_id' },
      { text: 'Habilitado Ind', value: 'ApiEnableRight_Ind' },
      { text: 'Actions', value: 'action', sortable: false }
    ],
    rolerights: [],
    processes: [],
    roles: [],
    editedIndex: -1,
    editedItem: {
      ApiRole_id: '',
      ApiProcess_id: '',
      ApiEnableRight_Ind: 'S'
    },
    defaultItem: {
      ApiRole_id: '',
      ApiProcess_id: '',
      ApiEnableRight_Ind: 'S'
    },
    idRules: [
      v => !!v || 'Rol ID es requerido',
      v => (v && v.length <= 50) || 'Rol ID debe tener menos de 30 caracteres'
    ],
    procidRules: [
      v => !!v || 'Proceso ID es requerido',
      v => (v && v.length <= 50) || 'Proceso ID debe tener menos de 30 caracteres'
    ],
    config: {
      headers: {
        //'Authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
        "api-user": sessionStorage.getItem('ApiUser_id')
      }
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Permiso' : 'Editar Permiso'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      axios.post(this.api_tool_url + '/get_rolerights', {}, this.config)
        .then(response => {
          this.rolerights = response.data.ResultRows
        })
        .catch(error => {
          this.rolerights = []
          alert(error.response.data.message)
        })

      axios.post(this.api_tool_url + '/get_apiprocess', {}, this.config)
        .then(response => {
          response.data.ResultRows.forEach(data => {
            this.processes.push(data.ApiProcess_id)
          })
        })
        .catch(error => {
          this.processes = []
          alert(error.response.data.message)
        })

      axios.post(this.api_tool_url + '/get_roles', {}, this.config)
        .then(response => {
          response.data.ResultRows.forEach(data => {
            this.roles.push(data.ApiRole_id)
          })
        })
        .catch(error => {
          this.roles = []
          alert(error.response.data.message)
        })
    },

    newtItem (item) {
      this.editedIndex = this.rolerights.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog_new = true
    },

    editItem (item) {
      this.editedIndex = this.rolerights.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.rolerights.indexOf(item)
      confirm('Are you sure you want to delete this item?') && this.deleteRoleUser(index)
    },

    deleteRoleUser (index) {
      let rolerightsTmp = this.rolerights[index]
      delete rolerightsTmp.ApiEnableRight_Ind
      axios.post(this.api_tool_url + '/del_rolerights', rolerightsTmp, this.config)
        .then(response => {
          this.rolerights.splice(index, 1)
          this.close()
        })
        .catch(error => {
          this.rolerights = []
          alert(error.response.data.message)
        })
    },

    close () {
      this.dialog = false
      this.dialog_new = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {
        axios.post(this.api_tool_url + '/upd_rolerights', this.editedItem, this.config)
          .then(response => {
            Object.assign(this.rolerights[this.editedIndex], response.data.ResultRows[0])
            this.close()
          })
          .catch(error => {
            this.rolerights = []
            alert(error.response.data.message)
          })
      } else {
        axios.post(this.api_tool_url + '/ins_rolerights', this.editedItem, this.config)
          .then(response => {
            this.rolerights.push(response.data.ResultRows[0])
            this.close()
          })
          .catch(error => {
            this.rolerights = []
            alert(error.response.data.message)
          })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RoleRightsGrid.vue